export const baseURL = process.env.REACT_APP_API_URL + "/api";

export const divisionMappings: Map<string, string> = new Map([
	["ligaen", "Ligaen"],
	["1div", "1 Division"],
	["2divA", "2 Division A"],
	["2divB", "2 Division B"],
	["3divA", "3 Division A"],
	["3divB", "3 Division B"],
	["3divC", "3 Division C"],
	["3divD", "3 Division D"],
	["4divA", "4 Division A"],
	["4divB", "4 Division B"],
	["4divC", "4 Division C"],
	["4divD", "4 Division D"],
	["5divA", "5 Division A"],
	["5divB", "5 Division B"],
]);

export const divisionMappingsSimple: Map<string, string> = new Map([
	["ligaen", "Ligaen"],
	["1div", "1 Division"],
	["2div", "2 Division"],
	["3div", "3 Division"],
	["4div", "4 Division"],
	["5div", "5 Division"],
]);

export const divisionMappingsSimpled: Map<string, string> = new Map([
	["ligaen", "Ligaen"],
	["1div", "1 Division"],
	["2div", "2 Division"],
	["3div", "3 Division"],
	["4div", "4 Division"],
]);

export const simpleDivisionMappings: Map<string, string> = new Map([
	["1", "Ligaen"],
	["2", "1 Division"],
	["3", "2 Division"],
	["4", "3 Division"],
	["5", "4 Division"],
	["6", "5 Division"],
]);

export const mapMappings: Map<string, string> = new Map([
	["de_dust2", "Dust 2"],
	["de_inferno", "Inferno"],
	["de_mirage", "Mirage"],
	["de_nuke", "Nuke"],
	["de_overpass", "Overpass"],
	["de_vertigo", "Vertigo"],
	["de_ancient", "Ancient"],
	["de_anubis", "Anubis"],
	["de_train", "Train"],
	["de_cache", "Cache"],
]);

export const roles = [
	"IGL",
	"Entry Fragger",
	"Support",
	"AWPer",
	"Lurker",
	"Rifler",
	"Coach",
	"Anchor",
];

export const currentSeason = 33;

//export const currentStandingSeason = 27;
export const trophyUsersS27 = [
	"76561198023098234",
	"76561198869052985",
	"76561199123600668",
	"76561198248762732",
	"76561198036882864",
];

export const trophyUsersS28 = [
	"76561199090908995",
	"76561199202092290",
	"76561198872944233",
	"76561198838416894",
	"76561198036882864",
];

export const trophyUsersS29 = [
	"76561198354610417",
	"76561198196115510",
	"76561199144028010",
	"76561198880752723",
	"76561198200697887",
];

export const trophyUsersS30 = [
	"76561198361899075", // BqreBedre - Ligaen
	"76561197995185323", // redeye - 1. Division
	"76561198455078990", // Half - 2. Division
	"76561198232488148", // Optimum - 3. Division
	"76561198009148887", // vestr - 4. Division
];

export const trophyUsersS31 = [
	"76561198124136504", // 1. Division
	"76561199090908995", // 2. Division
	"76561198875966014", // 3. Division
	"76561198201191395", // 4. Division
];

export const admins = ["76561198269061841", "76561198302139527", "76561198125971713"];

// The minigames and the public API explorer went public at the season 33 launch
// (2026-09-04); their dark-launch flags and self-gates are gone.

// Season Wrapped launch mechanics (tasks/wrapped-design.md). While false, the nudge popup + the
// profile-page Wrapped banner show for beta testers + admins only. Flip to true to open to
// everyone at launch. WRAPPED_SEASON is the season the nudge/banner point at.
export const WRAPPED_PUBLIC = true;
// Wrapped reviews a COMPLETED season, so this trails currentSeason by design.
export const WRAPPED_SEASON = 32;
// Last day the Wrapped PROMOS run (local time, inclusive). They are loud on purpose: the nudge
// re-pops on every visit until you actually view yours, and the profile banner pulses on every
// player page. That is right while last season is still the news, and obnoxious once the new
// season is underway (s33 grundspil kicked off 14 Sep 2026), so the promos expire on their own
// instead of waiting for someone to remember to remove them.
//
// This does NOT touch the /wrapped page itself — that stays live forever so shared links and
// profile-banner links from past seasons never rot. Only the promos go quiet.
// To re-run the promos for a new season: bump WRAPPED_SEASON and push this date out.
export const WRAPPED_PROMO_LAST_DAY = "2026-09-21";
// No timezone suffix on purpose — an ISO date-time without one parses as the VIEWER's local time,
// which is Danish time for essentially all of them.
export const wrappedPromoActive = (): boolean =>
    new Date() < new Date(`${WRAPPED_PROMO_LAST_DAY}T23:59:59`);

// Map control — the territory overlay in the replay viewer, and the Analysis "Map control" tab.
// While false, both are beta+admin only. The Analysis page is already beta-gated as a whole, so this
// flag really governs the replay-viewer toggle on the public match page.
//
// Shipped as ALPHA on purpose: the engine's ~15 tuning constants were swept by eye, several layers
// have already been corrected for measuring the wrong thing, and the per-player attribution is
// presence rather than credit. Read the numbers as pointers to rounds worth watching.
export const MAP_CONTROL_PUBLIC = false;

/**
 * @deprecated Use BadgeService.getAllBadges() instead - this is now database-backed
 * Kept for backwards compatibility until all components are migrated
 */
export const playerImages = [
	"6561199066108638",
	"76561197981010839",
	"76561197998469938",
	"76561198005496143",
	"76561198047652906",
	"76561198054946724",
	"76561198059322915",
	"76561198059636829",
	"76561198074859008",
	"76561198075693756",
	"76561198075772339",
	"76561198081246043",
	"76561198082225391",
	"76561198124136504",
	"76561198125971713",
	"76561198138532620",
	"76561198141477673",
	"76561198149417977",
	"76561198157504520",
	"76561198160006089",
	"76561198163517386",
	"76561198176005534",
	"76561198183348569",
	"76561198200697887",
	"76561198201191395",
	"76561198201496594",
	"76561198203780216",
	"76561198219555624",
	"76561198233292524",
	"76561198258148023",
	"76561198261133739",
	"76561198262758303",
	"76561198278140719",
	"76561198280530766",
	"76561198282538057",
	"76561198297876304",
	"76561198301442273",
	"76561198304901397",
	"76561198313091647",
	"76561198342818190",
	"76561198345015789",
	"76561198361899075",
	"76561198371339090",
	"76561198388382195",
	"76561198397764409",
	"76561198401642558",
	"76561198432023000",
	"76561198445123150",
	"76561198447521195",
	"76561198801417447",
	"76561198830173768",
	"76561198842197798",
	"76561198845508560",
	"76561198881189893",
	"76561198905721997",
	"76561198981175481",
	"76561198984376510",
	"76561199033760198",
	"76561199070740200",
	"76561199187413982",
	"76561198175924159",
	"76561198255211148",
	"76561198013173057",
	"76561199402846052",
	"76561198354610417",
	"76561199027952457",
	"76561199001414917",
	"76561198265857122",
	"76561198172714974",
	"76561198132040764",
	"76561198192433606",
	"76561198361961023",
	"76561198343413613",
	"76561198908622957",
	"76561198885573603",
	"76561198241397252",
	"76561198803068539",
	"76561198059956240",
	"76561198873438411"
];
export const strikelUsers = [
	"76561198011696279",
	"76561198269061841",
	"76561198125971713",
	"76561198172714974",
	"76561197974435680",
];

/**
 * @deprecated Use BadgeService.getAllBadges() instead - this is now database-backed
 * Verified content creators - Gets verified badge
 */
export const verifiedContentUsers: string[] = [
    "76561198125971713",
	"76561197983673093",
	"76561198205544503",
	"76561198258148023",
	"76561198201191395"
];
